import React from "react"
import { Route, Routes } from "react-router-dom"

function RouteWithSubRoutes(route) {
    return (
        <Route path={route.path} exact={route.exact} element={<route.component key={route.key} {...route} routes={route.routes} />}></Route>

    );
}

export default function RenderRoutes({ routes }) {
    return (
        <Routes>
            {routes.map((route, i) => {
                const key = route.key;
                delete route.key
                return <Route path={route.path} exact={route.exact} element={<route.component key={key} {...route} routes={route.routes} />}></Route>
                //return <RouteWithSubRoutes key={route.key} {...route} />
            })}
            <Route element={<h1>Not Found! (add not found component here)</h1>} />
        </Routes>
    )
}